export function decodeBase64Url(value) {
  const padding = `=`.repeat((4 - (value.length % 4)) % 4)
  const base64 = `${value}${padding}`.replace(/-/g, `+`).replace(/_/g, `/`)
  const bytes = window.atob(base64)
  const buffer = new ArrayBuffer(bytes.length)
  const view = new Uint8Array(buffer)

  for (let index = 0; index < bytes.length; index += 1) {
    view[index] = bytes.charCodeAt(index)
  }

  return buffer
}

export function encodeBase64Url(buffer) {
  const bytes = new Uint8Array(buffer)
  let binary = ``

  bytes.forEach((byte) => {
    binary += String.fromCharCode(byte)
  })

  return window
    .btoa(binary)
    .replace(/\+/g, `-`)
    .replace(/\//g, `_`)
    .replace(/=+$/g, ``)
}
